import { useGetModelInventoryStatusQuery } from '../../../core/apis/inventoryApi';
import { useGetCommonPayload, getQueryParamStr, DEALER_INVENTORY_ENDPOINT, DEFAULT_INVENTORY_STATUSES, } from '../../../core/apiHooks/useFetchInventoryStatus';
import { useAppSelector } from '../../../core/utils';
import { selectCurrentModelCodeAndColorCodes } from '../../../core/reducers/vehicles';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
/**
 * Fetch latest inventory status for current vehicle, when there is no
 * 'inventoryStatus' in query params, will try to return the other status
 * in response from the same vehicle
 *
 * @param {boolean} [shouldFetch=true]
 * @param {boolean} [refetchOnMountOrArgChange=false]
 * @param {number} [pollingInterval=0]
 */
const useFetchCurrentStatus = (shouldFetch = true, refetchOnMountOrArgChange = false, pollingInterval = 0) => {
    var _a, _b, _c, _d;
    const { url, headers, dealerCode } = useGetCommonPayload();
    const currentModelCodeAndColorCode = useAppSelector(selectCurrentModelCodeAndColorCodes);
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const params = {
        dealerCodes: getQueryParamStr(dealerCode),
        modelCodes: getQueryParamStr(currentModelCodeAndColorCode === null || currentModelCodeAndColorCode === void 0 ? void 0 : currentModelCodeAndColorCode.modelCode),
        extColors: getQueryParamStr(currentModelCodeAndColorCode === null || currentModelCodeAndColorCode === void 0 ? void 0 : currentModelCodeAndColorCode.colorCode),
        statuses: getQueryParamStr(DEFAULT_INVENTORY_STATUSES),
    };
    const isParamsValid = Object.values(params).every(value => !!value);
    const result = useGetModelInventoryStatusQuery({
        url: `${url}/${DEALER_INVENTORY_ENDPOINT}`,
        headers,
        params,
    }, {
        skip: !shouldFetch || !isParamsValid || !url,
        refetchOnMountOrArgChange,
        pollingInterval,
    });
    const dealerInventory = (_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.inventory;
    return {
        ...result,
        data: Array.isArray(dealerInventory) && dealerInventory.length > 1
            ? (_c = dealerInventory === null || dealerInventory === void 0 ? void 0 : dealerInventory.find(inventory => (inventory === null || inventory === void 0 ? void 0 : inventory.status) === inventoryStatus)) === null || _c === void 0 ? void 0 : _c.status
            : (_d = dealerInventory === null || dealerInventory === void 0 ? void 0 : dealerInventory[0]) === null || _d === void 0 ? void 0 : _d.status,
    };
};
export default useFetchCurrentStatus;
